/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MortgageInfo } from '../models/mortgage-info';

@Injectable({
  providedIn: 'root',
})
export class MortgageInfoService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getBuildingMortgageInfo
   */
  static readonly GetBuildingMortgageInfoPath = '/api/v1/MortgageInfo/Info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBuildingMortgageInfo$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBuildingMortgageInfo$Plain$Response(params?: {
    municipality?: string;
    section?: string;
    lotNumber?: string;
    apartmentRightSerialNumber?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MortgageInfo>> {

    const rb = new RequestBuilder(this.rootUrl, MortgageInfoService.GetBuildingMortgageInfoPath, 'get');
    if (params) {
      rb.query('municipality', params.municipality, {});
      rb.query('section', params.section, {});
      rb.query('lotNumber', params.lotNumber, {});
      rb.query('apartmentRightSerialNumber', params.apartmentRightSerialNumber, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MortgageInfo>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBuildingMortgageInfo$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBuildingMortgageInfo$Plain(params?: {
    municipality?: string;
    section?: string;
    lotNumber?: string;
    apartmentRightSerialNumber?: string;
  },
  context?: HttpContext

): Observable<MortgageInfo> {

    return this.getBuildingMortgageInfo$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<MortgageInfo>) => r.body as MortgageInfo)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBuildingMortgageInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBuildingMortgageInfo$Response(params?: {
    municipality?: string;
    section?: string;
    lotNumber?: string;
    apartmentRightSerialNumber?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<MortgageInfo>> {

    const rb = new RequestBuilder(this.rootUrl, MortgageInfoService.GetBuildingMortgageInfoPath, 'get');
    if (params) {
      rb.query('municipality', params.municipality, {});
      rb.query('section', params.section, {});
      rb.query('lotNumber', params.lotNumber, {});
      rb.query('apartmentRightSerialNumber', params.apartmentRightSerialNumber, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MortgageInfo>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBuildingMortgageInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBuildingMortgageInfo(params?: {
    municipality?: string;
    section?: string;
    lotNumber?: string;
    apartmentRightSerialNumber?: string;
  },
  context?: HttpContext

): Observable<MortgageInfo> {

    return this.getBuildingMortgageInfo$Response(params,context).pipe(
      map((r: StrictHttpResponse<MortgageInfo>) => r.body as MortgageInfo)
    );
  }

}
